import { RequiredFields } from '@prisma/client'
import { capitalize } from '../utils'
import { LeadsByPipelineOutput } from '../types/procedureOutputs'

// TODO: Make this as generic as possible so its compatible in a wide range of scenarios
export type ValidatableLead = LeadsByPipelineOutput['results'][number] /* {
  id: string
  type?: string
  company_name: string
  followup_date?: string | null
} & Record<RequiredFields, never>*/

type ValidateLeadError = { id: string; company_name: string; missingFields: RequiredFields[] }

const MoveLeadsService = {
  /**
   * Validates that the leads to be moved have the required information
   *   returns a list of the invalid Leads
   * @param leads
   * @param requiredFields
   * @private
   */
  validateLeads(
    leads: Array<ValidatableLead>,
    requiredFields: RequiredFields[]
  ): { invalidLeads: ValidateLeadError[]; missingFields: RequiredFields[] } {
    const invalidLeads: ValidateLeadError[] = []
    const allMissingFields = new Set<RequiredFields>()

    for (const lead of leads) {
      const leadMissingFields: RequiredFields[] = []

      for (const fieldName of requiredFields) {
        const value = this._getLeadByField(lead, fieldName)

        if (value === null || value === undefined || value === '') {
          // const originalFieldKey = REVERSE_FIELD_MAPPING[fieldName]
          // missingFields.push(DISPLAY_NAMES[originalFieldKey as keyof typeof DISPLAY_NAMES])
          leadMissingFields.push(fieldName)
          allMissingFields.add(fieldName)
        }
      }

      if (leadMissingFields.length > 0) {
        invalidLeads.push({
          id: lead.id,
          company_name: lead.company_name,
          missingFields: leadMissingFields
        })
      }
    }

    return { invalidLeads, missingFields: Array.from(allMissingFields) }
  },

  // getFieldValidationDisplayName
  getRequiredFieldDisplayName(field: RequiredFields) {
    switch (field) {
      case 'TERM_LENGTH':
        return 'Payment Frequency'
      case 'TERM_AMOUNT':
        return 'Number of Payments'
      case 'FINAL_PURCHASE_AMOUNT':
        return 'Final Purchase Amount (payback)'
      case 'FOLLOW_UP_DATE':
        return 'Followup Date'
      default:
        return capitalize(field.split('_'))
    }
  },

  /**
   * Takes a lead and a required field of type RequiredFields and returns the equivalent field on the lead object
   */
  _getLeadByField(lead: ValidatableLead, fieldName: RequiredFields): unknown {
    switch (fieldName) {
      case 'LEAD_TYPE':
        return lead['type']
      case 'FOLLOW_UP_DATE':
        return lead['followup_date']
    }

    return (lead as Record<string, unknown>)[fieldName.toLowerCase()]
  }
}

export default MoveLeadsService
